var exports = {
  "kL": "InlineEdit.module__container___aXg2Yj",
  "A": "InlineEdit.module__inlineTextBase___aXg2Yj",
  "Np": "InlineEdit.module__idleButton___aXg2Yj",
  "iE": "InlineEdit.module__wrapper___aXg2Yj",
  "qf": "InlineEdit.module__placeholder___aXg2Yj",
  "LL": "InlineEdit.module__editable___aXg2Yj",
  "NY": "InlineEdit.module__affix___aXg2Yj",
  "Qq": "InlineEdit.module__text___aXg2Yj",
  "z3": "InlineEdit.module__error___aXg2Yj",
};

module.exports = exports;
